// extracted by mini-css-extract-plugin
module.exports = {"background":"Body_background__3Wv8S","text":"Body_text__3E372","buttons":"Body_buttons__37SRg"};